/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityIncognitoSpyIcon20Solid = forwardRef('SecurityIncognitoSpyIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4.439 3.825 3.129 9H1a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2h-2.13l-1.309-5.175a2.4 2.4 0 0 0-3.695-1.383l-1.353.94a.9.9 0 0 1-1.026 0l-1.353-.94A2.4 2.4 0 0 0 4.44 3.825Z" }),
        React.createElement("path", { d: "M9.5 14.5v-.75h1v.75a3.25 3.25 0 1 0 6.5 0v-1.25c0-.69-.56-1.25-1.25-1.25H4.25C3.56 12 3 12.56 3 13.25v1.25a3.25 3.25 0 1 0 6.5 0Z" })));
});
